export default __webpack_public_path__ + "static/media/icon-triangle-alert.571212b7.svg";